import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { RootState } from "../../store";
import ProductManagement from "../Products/ProductManagement";
import ManageWarehouse from "./Management/ManageWarehouse";
import FloorInventoryPage from "./Floor/NewFloor";
import StoreInventoryPage from "./Store/NewStore";
import StockTransferTab from "./StockTransfer/StockTransferTab";

type TabKey =
  | "products"
  | "management"
  | "store"
  | "floor"
  | "newStore"
  | "newfloor"
  | "stockTransfer";

const Warehouse: React.FC = () => {
  const role = useSelector((state: RootState) => state.auth.role);
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = (() => {
    const tab = searchParams.get("tab") as TabKey | null;
    return tab &&
      [
        "products",
        "management",
        "store",
        "floor",
        "newfloor",
        "newStore",
        "stockTransfer",
      ].includes(tab)
      ? tab
      : "products";
  })() as TabKey;

  const setTab = (key: TabKey) => {
    setSearchParams({ tab: key }, { replace: true });
  };

  const tabs = useMemo(() => {
    const base = [{ key: "products" as TabKey, label: "Products" }];

    if (
      role === "admin" ||
      role === "factory" ||
      role === "bdm" ||
      role === "store"
    ) {
      base.push({ key: "management" as TabKey, label: "Management" });
    }
    if (role === "admin" || role === "store" || role === "factory") {
      base.push({ key: "store", label: "Store" });
    }
    if (
      role === "admin" ||
      role === "floor" ||
      role === "factory" ||
      role === "store"
    ) {
      base.push({ key: "floor", label: "Floor" });
    }
    if (role === "admin" || role === "store" || role === "factory") {
      base.push({ key: "stockTransfer", label: "Stock Transfer" });
    }

    return base;
  }, [role]);

  return (
    <div className="min-h-screen bg-slate-50 font-inter antialiased">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div
          className="grid mb-4 border-b border-gray-200"
          style={{ gridTemplateColumns: `10% repeat(${tabs.length}, 1fr) 10%` }}
        >
          <div />
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setTab(tab.key)}
              className={`text-center px-4 py-1 text-sm font-medium rounded-t-lg transition-all ${
                activeTab === tab.key
                  ? "text-blue-600 border-b-2 border-blue-500 bg-white"
                  : "text-gray-500 hover:text-gray-700 hover:bg-gray-50"
              }`}
            >
              {tab.label}
            </button>
          ))}
          <div />
        </div>

        {activeTab === "products" && <ProductManagement />}
        {activeTab === "management" &&
          (role === "admin" ||
            role === "factory" ||
            role === "bdm" ||
            role === "store") && <ManageWarehouse />}
        {/* {activeTab === "store" &&
          (role === "admin" || role === "store" || role === "factory") && (
            <StoreInwardTab />
          )}
        {activeTab === "floor" &&
          (role === "admin" || role === "floor" || role === "factory") && (
            <FloorInwardPage />
          )} */}
        {activeTab === "floor" &&
          (role === "admin" ||
            role === "floor" ||
            role === "factory" ||
            role === "store") && <FloorInventoryPage />}
        {activeTab === "store" &&
          (role === "admin" || role === "factory" || role === "store") && (
            <StoreInventoryPage />
          )}
        {activeTab === "stockTransfer" &&
          (role === "admin" || role === "factory" || role === "store") && (
            <StockTransferTab />
          )}
      </div>
    </div>
  );
};

export default Warehouse;
